<script lang="ts" module>
  import { tv } from '@/ui/tv';

  import CtaButton from '../buttons/CTAButton.svelte';
  import VersionBullet from './cmps/VersionBullet.svelte';
  import type { VersionItem } from './version.types';
  import VersionScore from './VersionScore.svelte';

  export interface VersionButtonProps<T extends VersionItem> {
    item: T;
    selected?: boolean;
    pos?: 'first' | 'last' | 'default';
    onclick?: (item: T) => void;
    onrestore?: (item: T) => void;
  }

  const styles = tv({
    slots: {
      root: 'group fr-cs relative w-full gap-2',
      content: 'f1',
    },
    variants: {
      pos: {
        first: {
          content: 'pb-1 pt-2',
        },
        last: {
          content: 'py-1',
        },
        default: {
          content: 'py-1',
        },
      },
    },
  });

  function getLabel(date: number | null | undefined) {
    if (!date) return 'Aktuelle Version';

    return new Date(date).toLocaleString('de', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
</script>

<script lang="ts" generics="T extends VersionItem">
  let { item, selected, pos, onclick, onrestore }: VersionButtonProps<T> = $props();
  let cn = $derived(styles({ pos }));
  let label = $derived(pos === 'first' ? 'Aktuelle Version' : getLabel(item.date));
</script>

<div
  class={cn.root()}
  onclick={() => onclick?.(item)}
  onkeypress={(e) => (e.key === 'Enter' || e.key === 'Space') && onclick?.(item)}
  role="button"
  tabindex="0"
>
  <VersionBullet {selected} {pos} />
  <div class={cn.content()}>
    <div class="fr-cc gap-2">
      <div
        class="fr-cs flex-1 gap-2 rounded-sm p-2 group-hover:bg-btn-tert-H group-focus:bg-btn-tert-H"
      >
        <div>
          {#if item.value != null}
            <VersionScore value={item.value} />
          {/if}
          <span class="text-label-sm">{label}</span>
        </div>
      </div>
      {#if selected && pos !== 'first'}
        <div class="ml-auto">
          <CtaButton
            class="py-3"
            icon="RestoreVersion"
            label="Wiederherstellen"
            tooltip="Wiederherstellen"
            onclick={() => onrestore?.(item)}
          />
        </div>
      {/if}
    </div>
    {#if pos === 'first'}
      <hr class="mt-2 border-t-c-divider" />
    {/if}
  </div>
</div>
